module.exports = __webpack_public_path__ + "media/components/src/assets/images/before_and_after/before_after_3-e7668fe4d7afca3a6af2578419942c6e.jpg";